import React from 'react';
import { isPlainObject, isIterable, isString, isMap, isSet } from '../utils/types';
import { customEntry as Symbol_customEntry, customValue as Symbol_customValue } from '../symbols';
import { Node } from './Node';
import { Leaf } from './Leaf';

const isNode = _ref => {
  let [, value] = _ref;
  return isPlainObject(value) || isMap(value) || isSet(value) || isIterable(value) && !isString(value);
};

export function Entry(_ref2) {
  var _data$, _data$2;

  let {
    data,
    depth
  } = _ref2;
  return /*#__PURE__*/React.createElement("li", null, (_data$ = data[1]) !== null && _data$ !== void 0 && _data$[Symbol_customEntry] ? data[1][Symbol_customEntry]() : (_data$2 = data[1]) !== null && _data$2 !== void 0 && _data$2[Symbol_customValue] ? /*#__PURE__*/React.createElement(Leaf, {
    data: data
  }) : isNode(data) ? /*#__PURE__*/React.createElement(Node, {
    depth: depth,
    data: data
  }) : /*#__PURE__*/React.createElement(Leaf, {
    data: data
  }));
}